import React from 'react';
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import routerConfig from "../../../config/router";
import apiSettings from '../../../config/api';
import appConst from '../../../config/const';
import './City.scss';

const City = (props) => {
  const {
    id,
    city,
    history,
  } = props;

  const createSrcPath = () =>{
    let src = '/assets/img/noimage.png';
    if(props[appConst.PHOTOS.small]){
      const image = props[appConst.PHOTOS.small];
      src = apiSettings.endpoints.genImageUrl(image, props.updatedAt);
    }
    return src;
  };

  return (
    <li
      role="presentation"
      onKeyDown={()=>{}}
      className="city__item"
      onClick={() => history.push(`${routerConfig.searchResult}/${id}?`)}
    >
      <div className="city__item-img">
        <img
          src={createSrcPath()}
          alt="."
        />
      </div>
      <p className="city__item-title">{city}</p>
    </li>
  )
};

City.propTypes = {
  id: PropTypes.number,
  city: PropTypes.string,
  history: PropTypes.object,
  updatedAt: PropTypes.string,
};

export default withRouter(City);


// WEBPACK FOOTER //
// ./src/app/containers/Home/components/City.js